import { fetch } from '@atlassian/eoc-fetch';

import { urls } from '../../../common/constants/urls';
import type { IncomingCallDetail } from '../../../common/types';

export const getDetail = (id: string): Promise<IncomingCallDetail> => {
	const endpoint = `${urls.incomingCall.detail.url(id)}`;

	return fetch<IncomingCallDetail>(endpoint);
};
